import { ErrorMessage, Field, useFormikContext, getIn } from "formik";
import { Company } from "models/Company";
import TextError from "./TextError";

type Props = {
    [x: string]: any;
}

const Input = (props:Props) => {
  const { errors, touched, values } = useFormikContext<Company>();
  const { label, name, ...rest } = props;

  const Label = () => {
    const labelClasses = () => {
      if(rest.labelclassname !== null) {
        return rest.labelclassname;
      }
      return "";
    }
    return (
      <>
      {label !== undefined ? (
          <label htmlFor={props.id} className={labelClasses() + " form-label"}>
            {label}
          </label>
        ) : (<></>)
      }
      </>
    )
  }

  return (
    <div className="mb-3">
      <Label />
      <Field
        className={`form-control ${Boolean(getIn(errors, name) && getIn(touched, name)) && "is-invalid"}`}
        name={name}
        id={props.id}
        {...rest}
        value={getIn(values, name) ? getIn(values, name) : ""}
      />
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

export default Input;
